import * as React from 'react';
import { Company } from './company';
import { Contract } from './contract';

export interface Profile {
  bio: string;
  city: string;
  company_id?: string;
  company: Company | null;
  country: string;
  created_at: string;
  email: string;
  id: string;
  image_url: string;
  is_verified: boolean;
  last_login?: string;
  name: string;
  token: string;
  type: string;
}

export interface ProfileManager {
  profile: Profile;
  reset: Function;
  set: Function;
}

interface ElementWithChildren {
  children: React.ReactElement<any>;
}

// Initial state is empty given the user is not authenticated
// Could extend this and persist to local storage
const initialState = JSON.parse(localStorage.getItem('profile'));

const ProfileContext = React.createContext<ProfileManager>(null);

// Provider creates a local state of the profile and exposes an interface
// For retrieving, setting and reseting profile data
function ProfileContextProvider(props: ElementWithChildren) {
  const [profile, setProfile] = React.useState(initialState);
  const value: ProfileManager = {
    profile,
    reset: () => setProfile(null),
    set: (newProfile: Profile) => {
      localStorage.setItem('profile', JSON.stringify(newProfile));
      setProfile(newProfile);
    },
  };

  return (
    <ProfileContext.Provider value={value}>
      {props.children}
    </ProfileContext.Provider>
  );
}

const ProfileContextConsumer = ProfileContext.Consumer;

export { ProfileContext, ProfileContextProvider, ProfileContextConsumer };
